'use strict';

var _defineProperty = require("/home/vsts/work/1/s/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var hasOwnProperty = Object.prototype.hasOwnProperty;
var stringify = configure(); // @ts-expect-error

stringify.configure = configure; // @ts-expect-error

stringify.stringify = stringify; // @ts-expect-error

stringify.default = stringify; // @ts-expect-error used for named export

exports.stringify = stringify; // @ts-expect-error used for named export

exports.configure = configure;
module.exports = stringify; // eslint-disable-next-line no-control-regex

var strEscapeSequencesRegExp = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]|[\ud800-\udbff](?![\udc00-\udfff])|(?:[^\ud800-\udbff]|^)[\udc00-\udfff]/; // Escape C0 control characters, double quotes, the backslash and every code
// unit with a numeric value in the inclusive range 0xD800 to 0xDFFF.

function strEscape(str) {
  // Some magic numbers that worked out fine while benchmarking with v8 8.0
  if (str.length < 5000 && !strEscapeSequencesRegExp.test(str)) {
    return "\"".concat(str, "\"");
  }

  return JSON.stringify(str);
}

function insertSort(array) {
  // Insertion sort is very efficient for small input sizes but it has a bad
  // worst case complexity. Thus, use native array sort for bigger values.
  if (array.length > 2e2) {
    return array.sort();
  }

  for (var i = 1; i < array.length; i++) {
    var currentValue = array[i];
    var position = i;

    while (position !== 0 && array[position - 1] > currentValue) {
      array[position] = array[position - 1];
      position--;
    }

    array[position] = currentValue;
  }

  return array;
}

var typedArrayPrototypeGetSymbolToStringTag = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(Object.getPrototypeOf(new Int8Array())), Symbol.toStringTag).get;

function isTypedArrayWithEntries(value) {
  return typedArrayPrototypeGetSymbolToStringTag.call(value) !== undefined && value.length !== 0;
}

function stringifyTypedArray(array, separator, maximumBreadth) {
  if (array.length < maximumBreadth) {
    maximumBreadth = array.length;
  }

  var whitespace = separator === ',' ? '' : ' ';
  var res = "\"0\":".concat(whitespace).concat(array[0]);

  for (var i = 1; i < maximumBreadth; i++) {
    res += "".concat(separator, "\"").concat(i, "\":").concat(whitespace).concat(array[i]);
  }

  return res;
}

function getCircularValueOption(options) {
  if (hasOwnProperty.call(options, 'circularValue')) {
    var circularValue = options.circularValue;

    if (typeof circularValue === 'string') {
      return "\"".concat(circularValue, "\"");
    }

    if (circularValue == null) {
      return circularValue;
    }

    if (circularValue === Error || circularValue === TypeError) {
      return {
        toString: function toString() {
          throw new TypeError('Converting circular structure to JSON');
        }
      };
    }

    throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined');
  }

  return '"[Circular]"';
}

function getBooleanOption(options, key) {
  var value;

  if (hasOwnProperty.call(options, key)) {
    value = options[key];

    if (typeof value !== 'boolean') {
      throw new TypeError("The \"".concat(key, "\" argument must be of type boolean"));
    }
  }

  return value === undefined ? true : value;
}

function getPositiveIntegerOption(options, key) {
  var value;

  if (hasOwnProperty.call(options, key)) {
    value = options[key];

    if (typeof value !== 'number') {
      throw new TypeError("The \"".concat(key, "\" argument must be of type number"));
    }

    if (!Number.isInteger(value)) {
      throw new TypeError("The \"".concat(key, "\" argument must be an integer"));
    }

    if (value < 1) {
      throw new RangeError("The \"".concat(key, "\" argument must be >= 1"));
    }
  }

  return value === undefined ? Infinity : value;
}

function getItemCount(number) {
  if (number === 1) {
    return '1 item';
  }

  return "".concat(number, " items");
}

function getUniqueReplacerSet(replacerArray) {
  var replacerSet = new Set();

  var _iterator = _createForOfIteratorHelper(replacerArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;

      if (typeof value === 'string' || typeof value === 'number') {
        replacerSet.add(String(value));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return replacerSet;
}

function getStrictOption(options) {
  if (hasOwnProperty.call(options, 'strict')) {
    var value = options.strict;

    if (typeof value !== 'boolean') {
      throw new TypeError('The "strict" argument must be of type boolean');
    }

    if (value) {
      return function (value) {
        var message = "Object can not safely be stringified. Received type ".concat(typeof value);
        if (typeof value !== 'function') message += " (".concat(value.toString(), ")");
        throw new Error(message);
      };
    }
  }
}

function configure(options) {
  options = _objectSpread({}, options);
  var fail = getStrictOption(options);

  if (fail) {
    if (options.bigint === undefined) {
      options.bigint = false;
    }

    if (!('circularValue' in options)) {
      options.circularValue = Error;
    }
  }

  var circularValue = getCircularValueOption(options);
  var bigint = getBooleanOption(options, 'bigint');
  var deterministic = getBooleanOption(options, 'deterministic');
  var maximumDepth = getPositiveIntegerOption(options, 'maximumDepth');
  var maximumBreadth = getPositiveIntegerOption(options, 'maximumBreadth');

  function stringifyFnReplacer(key, parent, stack, replacer, spacer, indentation) {
    var value = parent[key];

    if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') {
      value = value.toJSON(key);
    }

    value = replacer.call(parent, key, value);

    switch (typeof value) {
      case 'string':
        return strEscape(value);

      case 'object':
        {
          if (value === null) {
            return 'null';
          }

          if (stack.indexOf(value) !== -1) {
            return circularValue;
          }

          var res = '';
          var join = ',';
          var originalIndentation = indentation;

          if (Array.isArray(value)) {
            if (value.length === 0) {
              return '[]';
            }

            if (maximumDepth < stack.length + 1) {
              return '"[Array]"';
            }

            stack.push(value);

            if (spacer !== '') {
              indentation += spacer;
              res += "\n".concat(indentation);
              join = ",\n".concat(indentation);
            }

            var maximumValuesToStringify = Math.min(value.length, maximumBreadth);
            var i = 0;

            for (; i < maximumValuesToStringify - 1; i++) {
              var _tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation);

              res += _tmp !== undefined ? _tmp : 'null';
              res += join;
            }

            var tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation);
            res += tmp !== undefined ? tmp : 'null';

            if (value.length - 1 > maximumBreadth) {
              var removedKeys = value.length - maximumBreadth - 1;
              res += "".concat(join, "\"... ").concat(getItemCount(removedKeys), " not stringified\"");
            }

            if (spacer !== '') {
              res += "\n".concat(originalIndentation);
            }

            stack.pop();
            return "[".concat(res, "]");
          }

          var keys = Object.keys(value);
          var keyLength = keys.length;

          if (keyLength === 0) {
            return '{}';
          }

          if (maximumDepth < stack.length + 1) {
            return '"[Object]"';
          }

          var whitespace = '';
          var separator = '';

          if (spacer !== '') {
            indentation += spacer;
            join = ",\n".concat(indentation);
            whitespace = ' ';
          }

          var maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);

          if (deterministic && !isTypedArrayWithEntries(value)) {
            keys = insertSort(keys);
          }

          stack.push(value);

          for (var _i = 0; _i < maximumPropertiesToStringify; _i++) {
            var _key = keys[_i];

            var _tmp2 = stringifyFnReplacer(_key, value, stack, replacer, spacer, indentation);

            if (_tmp2 !== undefined) {
              res += "".concat(separator).concat(strEscape(_key), ":").concat(whitespace).concat(_tmp2);
              separator = join;
            }
          }

          if (keyLength > maximumBreadth) {
            var _removedKeys = keyLength - maximumBreadth;

            res += "".concat(separator, "\"...\":").concat(whitespace, "\"").concat(getItemCount(_removedKeys), " not stringified\"");
            separator = join;
          }

          if (spacer !== '' && separator.length > 1) {
            res = "\n".concat(indentation).concat(res, "\n").concat(originalIndentation);
          }

          stack.pop();
          return "{".concat(res, "}");
        }

      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null';

      case 'boolean':
        return value === true ? 'true' : 'false';

      case 'undefined':
        return undefined;

      case 'bigint':
        if (bigint) {
          return String(value);
        }

      // fallthrough

      default:
        return fail ? fail(value) : undefined;
    }
  }

  function stringifyArrayReplacer(key, value, stack, replacer, spacer, indentation) {
    if (typeof value === 'object' && value !== null && typeof value.toJSON === 'function') {
      value = value.toJSON(key);
    }

    switch (typeof value) {
      case 'string':
        return strEscape(value);

      case 'object':
        {
          if (value === null) {
            return 'null';
          }

          if (stack.indexOf(value) !== -1) {
            return circularValue;
          }

          var originalIndentation = indentation;
          var res = '';
          var join = ',';

          if (Array.isArray(value)) {
            if (value.length === 0) {
              return '[]';
            }

            if (maximumDepth < stack.length + 1) {
              return '"[Array]"';
            }

            stack.push(value);

            if (spacer !== '') {
              indentation += spacer;
              res += "\n".concat(indentation);
              join = ",\n".concat(indentation);
            }

            var maximumValuesToStringify = Math.min(value.length, maximumBreadth);
            var i = 0;

            for (; i < maximumValuesToStringify - 1; i++) {
              var _tmp3 = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation);

              res += _tmp3 !== undefined ? _tmp3 : 'null';
              res += join;
            }

            var tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation);
            res += tmp !== undefined ? tmp : 'null';

            if (value.length - 1 > maximumBreadth) {
              var removedKeys = value.length - maximumBreadth - 1;
              res += "".concat(join, "\"... ").concat(getItemCount(removedKeys), " not stringified\"");
            }

            if (spacer !== '') {
              res += "\n".concat(originalIndentation);
            }

            stack.pop();
            return "[".concat(res, "]");
          }

          stack.push(value);
          var whitespace = '';

          if (spacer !== '') {
            indentation += spacer;
            join = ",\n".concat(indentation);
            whitespace = ' ';
          }

          var separator = '';

          var _iterator2 = _createForOfIteratorHelper(replacer),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _key2 = _step2.value;

              var _tmp4 = stringifyArrayReplacer(_key2, value[_key2], stack, replacer, spacer, indentation);

              if (_tmp4 !== undefined) {
                res += "".concat(separator).concat(strEscape(_key2), ":").concat(whitespace).concat(_tmp4);
                separator = join;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (spacer !== '' && separator.length > 1) {
            res = "\n".concat(indentation).concat(res, "\n").concat(originalIndentation);
          }

          stack.pop();
          return "{".concat(res, "}");
        }

      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null';

      case 'boolean':
        return value === true ? 'true' : 'false';

      case 'undefined':
        return undefined;

      case 'bigint':
        if (bigint) {
          return String(value);
        }

      // fallthrough

      default:
        return fail ? fail(value) : undefined;
    }
  }

  function stringifyIndent(key, value, stack, spacer, indentation) {
    switch (typeof value) {
      case 'string':
        return strEscape(value);

      case 'object':
        {
          if (value === null) {
            return 'null';
          }

          if (typeof value.toJSON === 'function') {
            value = value.toJSON(key); // Prevent calling `toJSON` again.

            if (typeof value !== 'object') {
              return stringifyIndent(key, value, stack, spacer, indentation);
            }

            if (value === null) {
              return 'null';
            }
          }

          if (stack.indexOf(value) !== -1) {
            return circularValue;
          }

          var originalIndentation = indentation;

          if (Array.isArray(value)) {
            if (value.length === 0) {
              return '[]';
            }

            if (maximumDepth < stack.length + 1) {
              return '"[Array]"';
            }

            stack.push(value);
            indentation += spacer;

            var _res = "\n".concat(indentation);

            var _join = ",\n".concat(indentation);

            var maximumValuesToStringify = Math.min(value.length, maximumBreadth);
            var i = 0;

            for (; i < maximumValuesToStringify - 1; i++) {
              var _tmp5 = stringifyIndent(String(i), value[i], stack, spacer, indentation);

              _res += _tmp5 !== undefined ? _tmp5 : 'null';
              _res += _join;
            }

            var tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation);
            _res += tmp !== undefined ? tmp : 'null';

            if (value.length - 1 > maximumBreadth) {
              var removedKeys = value.length - maximumBreadth - 1;
              _res += "".concat(_join, "\"... ").concat(getItemCount(removedKeys), " not stringified\"");
            }

            _res += "\n".concat(originalIndentation);
            stack.pop();
            return "[".concat(_res, "]");
          }

          var keys = Object.keys(value);
          var keyLength = keys.length;

          if (keyLength === 0) {
            return '{}';
          }

          if (maximumDepth < stack.length + 1) {
            return '"[Object]"';
          }

          indentation += spacer;
          var join = ",\n".concat(indentation);
          var res = '';
          var separator = '';
          var maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);

          if (isTypedArrayWithEntries(value)) {
            res += stringifyTypedArray(value, join, maximumBreadth);
            keys = keys.slice(value.length);
            maximumPropertiesToStringify -= value.length;
            separator = join;
          }

          if (deterministic) {
            keys = insertSort(keys);
          }

          stack.push(value);

          for (var _i2 = 0; _i2 < maximumPropertiesToStringify; _i2++) {
            var _key3 = keys[_i2];

            var _tmp6 = stringifyIndent(_key3, value[_key3], stack, spacer, indentation);

            if (_tmp6 !== undefined) {
              res += "".concat(separator).concat(strEscape(_key3), ": ").concat(_tmp6);
              separator = join;
            }
          }

          if (keyLength > maximumBreadth) {
            var _removedKeys2 = keyLength - maximumBreadth;

            res += "".concat(separator, "\"...\": \"").concat(getItemCount(_removedKeys2), " not stringified\"");
            separator = join;
          }

          if (separator !== '') {
            res = "\n".concat(indentation).concat(res, "\n").concat(originalIndentation);
          }

          stack.pop();
          return "{".concat(res, "}");
        }

      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null';

      case 'boolean':
        return value === true ? 'true' : 'false';

      case 'undefined':
        return undefined;

      case 'bigint':
        if (bigint) {
          return String(value);
        }

      // fallthrough

      default:
        return fail ? fail(value) : undefined;
    }
  }

  function stringifySimple(key, value, stack) {
    switch (typeof value) {
      case 'string':
        return strEscape(value);

      case 'object':
        {
          if (value === null) {
            return 'null';
          }

          if (typeof value.toJSON === 'function') {
            value = value.toJSON(key); // Prevent calling `toJSON` again

            if (typeof value !== 'object') {
              return stringifySimple(key, value, stack);
            }

            if (value === null) {
              return 'null';
            }
          }

          if (stack.indexOf(value) !== -1) {
            return circularValue;
          }

          var res = '';

          if (Array.isArray(value)) {
            if (value.length === 0) {
              return '[]';
            }

            if (maximumDepth < stack.length + 1) {
              return '"[Array]"';
            }

            stack.push(value);
            var maximumValuesToStringify = Math.min(value.length, maximumBreadth);
            var i = 0;

            for (; i < maximumValuesToStringify - 1; i++) {
              var _tmp7 = stringifySimple(String(i), value[i], stack);

              res += _tmp7 !== undefined ? _tmp7 : 'null';
              res += ',';
            }

            var tmp = stringifySimple(String(i), value[i], stack);
            res += tmp !== undefined ? tmp : 'null';

            if (value.length - 1 > maximumBreadth) {
              var removedKeys = value.length - maximumBreadth - 1;
              res += ",\"... ".concat(getItemCount(removedKeys), " not stringified\"");
            }

            stack.pop();
            return "[".concat(res, "]");
          }

          var keys = Object.keys(value);
          var keyLength = keys.length;

          if (keyLength === 0) {
            return '{}';
          }

          if (maximumDepth < stack.length + 1) {
            return '"[Object]"';
          }

          var separator = '';
          var maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);

          if (isTypedArrayWithEntries(value)) {
            res += stringifyTypedArray(value, ',', maximumBreadth);
            keys = keys.slice(value.length);
            maximumPropertiesToStringify -= value.length;
            separator = ',';
          }

          if (deterministic) {
            keys = insertSort(keys);
          }

          stack.push(value);

          for (var _i3 = 0; _i3 < maximumPropertiesToStringify; _i3++) {
            var _key4 = keys[_i3];

            var _tmp8 = stringifySimple(_key4, value[_key4], stack);

            if (_tmp8 !== undefined) {
              res += "".concat(separator).concat(strEscape(_key4), ":").concat(_tmp8);
              separator = ',';
            }
          }

          if (keyLength > maximumBreadth) {
            var _removedKeys3 = keyLength - maximumBreadth;

            res += "".concat(separator, "\"...\":\"").concat(getItemCount(_removedKeys3), " not stringified\"");
          }

          stack.pop();
          return "{".concat(res, "}");
        }

      case 'number':
        return isFinite(value) ? String(value) : fail ? fail(value) : 'null';

      case 'boolean':
        return value === true ? 'true' : 'false';

      case 'undefined':
        return undefined;

      case 'bigint':
        if (bigint) {
          return String(value);
        }

      // fallthrough

      default:
        return fail ? fail(value) : undefined;
    }
  }

  function stringify(value, replacer, space) {
    if (arguments.length > 1) {
      var spacer = '';

      if (typeof space === 'number') {
        spacer = ' '.repeat(Math.min(space, 10));
      } else if (typeof space === 'string') {
        spacer = space.slice(0, 10);
      }

      if (replacer != null) {
        if (typeof replacer === 'function') {
          return stringifyFnReplacer('', {
            '': value
          }, [], replacer, spacer, '');
        }

        if (Array.isArray(replacer)) {
          return stringifyArrayReplacer('', value, [], getUniqueReplacerSet(replacer), spacer, '');
        }
      }

      if (spacer.length !== 0) {
        return stringifyIndent('', value, [], spacer, '');
      }
    }

    return stringifySimple('', value, []);
  }

  return stringify;
}